import * as React from 'react';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';

// Utils
import { useTranslation } from 'react-i18next'
import { InputContainer, InputText } from './styles';
import { Divider } from '@mui/material';

export const SearchBarWorkflows = ({
    setFilteredRequest,
    rows,
    filterText,
    maintainFilter,
    clearFilter,
    setSearchText
}) => {

    const { t } = useTranslation();
    const [search, setSearch] = React.useState('');

    React.useEffect(() => {
        setSearch('')
    }, [clearFilter])

    function handleSearch(e) {
        setSearch(e)
        setSearchText(e)
    }


    return (
        <InputContainer
            component="form"
            elevation={0}
        >
            <IconButton type="button" sx={{ p: '5px' }} aria-label="search" disabled>
                <SearchIcon />
            </IconButton>
            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <InputText
                type='text'
                name='search'
                value={search}
                onChange={e => handleSearch(e.target.value)}
                autoComplete='off'
                placeholder={filterText || t('common.searchBars.workflows')}
                inputProps={{ 'aria-label': 'search google maps' }}
            />
        </InputContainer>
    );
}